const $ = window.jQuery

import Swiper, { Navigation, Pagination, Thumbs } from 'swiper';

import { debounce, throttle } from 'lodash';

import utils from './utils';
import appUtils from './app_utils'


const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

class GenericCarousel {
  constructor(target, args = {}) {
    this.target = target

    this.$el = $(this.target)

    this.$window = appUtils.$window

    this.swpInstance = null

    this.autoScrollSpeed = args.speed || 5

    this.autoScollDelta = 0

    this.autoScrollDisable = false

    this.animationFrameId = null

    this.slidesTotalWidth = 0

    this.$counter = null

    this.refAlignLeft = null

    this.refOffsetRight = null

    this.slidesTotal = this.$el.find('.swiper-wrapper').children().length // before cloning

    this.locked = false

    this.swpThumbsInstance = false

    if(!this.$el.attr('data-swiper-locked')){
      this.init()
    } else {
      this.locked = true
    }
  }

  init() {
    const params_default = {
       modules: [Navigation, Pagination, Thumbs],
       speed: 300,
       spaceBetween: 0,
       threshold: 20,
       slidesPerView: 'auto',
       on: {
         slideChangeTransitionStart: () => this.carouselSlideChangeStart(),
         slideChangeTransitionEnd: () => this.carouselSlideChangeEnd()
       },
       pagination: {
         el: this.$el.find('.swiper-pagination')[0],
         clickable: true,
         renderBullet: function (index, className) {
           return '<span class="' + className + '">' + (index + 1) + '</span>';
         },
       },
    }

    let params = {}
    if(this.$el.attr('data-swiper')) {
      params = Object.assign({}, params_default, getAttributeObject(this.$el.attr('data-swiper')))
    } else {
      params = Object.assign({}, params_default)
    }

    if(this.slidesTotal < 2) {
      params.pagination = false
      params.allowTouchMove = false
      params.followFinger = false
      params.shortSwipes = false
      params.longSwipes = false
    }

    if(this.$el.attr('data-swiper-centered-slides')){
      params.centeredSlides = true
    }
    if(this.$el.attr('data-swiper-center')){
      params.centerInsufficientSlides = true
    }
    if(this.$el.attr('data-swiper-loop')){ // || this.$el.attr('data-swiper-autoscroll')
      // params.freeMode = true
      params.loop = true
    }

    if(!this.$el.attr('data-swiper-autoscroll') && this.$el.attr('data-swiper-keyboard')){
      params.keyboard = {
				enabled: true,
				onlyInViewport: true
			}
    }

    if(this.$el.attr('data-swiper-lazy')){
      params.preloadImages = false
			params.lazy = {
				loadPrevNext: true
			}
    } else {
      if(this.$el.attr('data-swiper-preload')){
        if(this.$el.attr('data-swiper-preload')==='false'){
          params.preloadImages = false
        }
      }
    }

    if(this.$el.attr('data-swiper-navigation')){
      params.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }

    if(this.$el.attr('data-swiper-locked')){
      //params.followFinger = false
      params.simulateTouch = false
      //params.allowTouchMove = false
    }


    if (this.$el.next('[data-swiper-thumbs]').length) {
      this.swpThumbsInstance = new Swiper(this.$el.next('[data-swiper-thumbs]')[0], {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
      })
      
      // https://swiperjs.com/demos/300-thumbs-gallery/core
      params.thumbs = {
        swiper: this.swpThumbsInstance
      }
      
    }

    this.swpInstance = new Swiper(this.target, params)

    if (this.$el.attr('data-swiper-counter')){
      let $counter = $('<div class="counter">1 / ' + this.slidesTotal + '</div>') //this.swpInstance.slides.length
      this.$el.append($counter)
      this.$counter = $counter
    }

    if (this.$el.attr('data-swiper-align')){
      let $refAlignLeft = $(this.$el.attr('data-swiper-align')).first()
      if($refAlignLeft.length){
        this.refAlignLeft = $refAlignLeft[0]
      }
    } else if (this.$el.attr('data-swiper-offset-right')) {
      let refOffsetRight = this.$el.parent()[0]
      this.refOffsetRight= refOffsetRight
    }
    

    this.onResize()

    if (this.$el.attr('data-swiper-autoscroll') && !window.Modernizr.touchevents){
      //this.$el.on('mouseover', e => this.onMouseOver(e)) //this.onMouseOver.bind(this)
      //this.$el.on('mouseout', e => this.checkAndAnimationFrame(e))
      this.$el.on('mousemove', e => this.onMouseMove(e))
      this.checkAndAnimationFrame()
    }

    this.carouselSlideChangeEnd()
  }

  destroy() {
    this.stopAnimationFrame()
    this.$el.off('mouseover')
    this.$el.off('mouseout')
    this.$el.off('mousemove')
    if(this.swpInstance){
      this.swpInstance.destroy()
      this.swpInstance = null
    }
  }

  lockToggle() {
    this.locked = !this.locked
    if(!this.locked) {
      this.init()
    } else {
      //this.swpInstance.setTranslate(0)
      this.stopAnimationFrame()
      this.swpInstance.slideTo(0, 500, false);
      setTimeout(() => {
        this.destroy()
      }, 500)
    }
  }

  carouselSlideChangeStart() {
    this.$window.trigger('carousel:slideChangeStart', this)
  }

  carouselSlideChangeEnd() {
    this.$window.trigger('carousel:slideChangeEnd', this)
    if (this.$counter) {
      this.$counter.html((this.swpInstance.activeIndex + 1) + ' / ' + this.slidesTotal);
    }
  }

  animationFrameFunction() {
    this.animationFrameId = requestAnimationFrame(() => {
      if (this.autoScrollDisable) {
        return
      }

      let t = this.swpInstance.getTranslate() - this.autoScollDelta
      // if (Math.abs(t) > this.slidesTotalWidth) {
      //   let delta = (t < 0) ? this.slidesTotalWidth : -this.slidesTotalWidth
      //   t = t + delta
      // }
      if (((this.slidesTotalWidth + t) > window.outerWidth) && t < 0) {
        this.swpInstance.setTranslate(t)
      }
      this.animationFrameFunction()
    })
  }

  onMouseMove(e) {
    this.autoScollDelta = (2 * (e.pageX - e.currentTarget.clientWidth /2) / e.currentTarget.clientWidth) * this.autoScrollSpeed
  }

  onMouseOver() {
    this.autoScrollDisable = true
  }

  checkAndAnimationFrame() {
    if (this.slidesTotalWidth < this.$el.width()) {
      this.autoScrollDisable = true
    } else {
      this.autoScrollDisable = false
    }
    this.animationFrameFunction()
  }

  stopAnimationFrame() {
    this.autoScrollDisable = false
    if(this.animationFrameId){
      if (cancelAnimationFrame) {
        cancelAnimationFrame(this.animationFrameId)
      }
    }
  }

  onResize() {
    if(!this.swpInstance) {
      return false
    }

    if(this.refAlignLeft && this.swpInstance) {
      let rect = this.refAlignLeft.getBoundingClientRect()
      this.$el.css('padding-left', rect.left + 'px')
      this.swpInstance.update()
    }

    if(this.refOffsetRight && this.swpInstance) {
      let rect = this.refOffsetRight.getBoundingClientRect()
      this.$el.css('right', (rect.right - this.$window.width() + 20) + 'px')
      this.swpInstance.update()
    }

    if(this.swpInstance) { //this.animationFrameId &&
      let wd = 0
      for(var j=0; j< this.swpInstance.slides.length; j++) {
        let s = this.swpInstance.slides[j]
        if(!s.classList.contains('swiper-slide-duplicate')) {
          wd += s.clientWidth
        }
      }
      this.slidesTotalWidth = wd
    }


    if (this.slidesTotalWidth < this.$el.width()) {
      this.autoScrollDisable = true
    } else {
      this.autoScrollDisable = false
    }
  }
}

let carouselInstances = []

let onWindowResize = function(){
  if (carouselInstances.length) {
    for(var i=0; i<carouselInstances.length; i++){
      carouselInstances[i].onResize()
    }
  }
}

let onWindowResizeThrottle = throttle(onWindowResize, 200)

let featuredworksLockToggle = function featuredworksLockToggle(e) {
  let selector = $(this).attr('data-featuredworks-lock-toggle')
  let carousel = $(selector).data('carousel-instance')
  if(carousel){
    carousel.lockToggle()
    if(!carousel.locked){
      appUtils.scrollTo('.featuredworks-wrapper')
      //setTimeout(()=>{
        $(selector).find('[data-tip-enable]').attr('data-tip-in', 'true')
        $(selector).closest('.featuredworks-wrapper').addClass('carousel--on')
      //}, 400)
    } else {
      $(selector).find('[data-tip-enable]').removeAttr('data-tip-in')
      $(selector).closest('.featuredworks-wrapper').removeClass('carousel--on')
    }
  }
}

const init = function() {
  $('[data-swiper]').each(function() {
    let carousel = new GenericCarousel(this)
    carousel.$el.data('carousel-instance', carousel)
    carouselInstances.push(carousel)
  })
  appUtils.$window.on('resize', onWindowResizeThrottle)

  $('[data-featuredworks-lock-toggle]').on('click', featuredworksLockToggle)
}

const destroy = function() {
  if (carouselInstances.length) {
    for(var i=0; i<carouselInstances.length; i++){
      carouselInstances[i].$el.data('carousel-instance', null)
      carouselInstances[i].destroy()
    }
    carouselInstances = []
  }
  appUtils.$window.off('resize', onWindowResizeThrottle)
}

const update = function(){
  if (carouselInstances.length) {
    for(var i=0; i<carouselInstances.length; i++){
      carouselInstances[i].swpInstance.update()
      carouselInstances[i].onResize()
    }
  }
}

export default {init, destroy, update}
